import React, { FormEvent, useState } from "react";
import { TextField, Button, Typography } from "@mui/material";
import styles from "./EnderecoForm.module.css";
import styles_button from "../../../styles/Button.module.css";
import { useCadastro } from "../../../resources/CadastroProvider";
import { estadosBrasileiros } from "../../../resources/Dados";
import CepField from "../../atoms/CepField/CepField";
import SelectField from "../../atoms/SelectField/SelectField";

interface Props {
  edit?: boolean;
}

const EnderecoForm = ({ edit }: Props) => {
  const {
    steps,
    setStepCompletedAtIndex,
    addressData,
    setAddressData,
    handlePrevStep,
    handleNextStep,
    handleUpdateUser,
    loadingUpdate,
  } = useCadastro();

  const [mensagem, setMensagem] = useState<string>("");
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleCEPChange = (data: any) => {
    setAddressData((prev) => ({
      ...prev,
      cep: data.cep || prev.cep,
      logradouro: data.logradouro || prev.logradouro,
      bairro: data.bairro || prev.bairro,
      cidade: data.localidade || prev.cidade,
      uf: data.uf || prev.uf,
    }));
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: keyof typeof addressData,
  ) => {
    setAddressData({
      ...addressData,
      [field]: e.target.value,
    });
  };

  const handleNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const num = e.target.value.replace(/\D/g, ""); // Remove caracteres não numÃ©ricos
    setAddressData({
      ...addressData,
      numero: num || "0", // Garante que sempre haverÃ¡ um valor string válido
    });
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    setMensagem("");
    setErrors({});

    const indexStep = steps.findIndex(
      (step) => step.label === "Dados de Endereço",
    );

    if (indexStep !== -1) {
      setStepCompletedAtIndex(indexStep, false);
    }

    const validationErrors: Record<string, string> = {};

    if (!addressData.cep || String(addressData.cep).trim() === "") {
      validationErrors.cep = "Informe o CEP.";
    }

    if (!addressData.cidade || String(addressData.cidade).trim() === "") {
      validationErrors.cidade = "Informe a cidade.";
    }

    if (!addressData.uf || String(addressData.uf).trim() === "") {
      validationErrors.uf = "Selecione o Estado.";
    }

    if (!addressData.logradouro || String(addressData.logradouro).trim() === "") {
      validationErrors.logradouro = "Informe o endereço.";
    }

    if (!addressData.numero || String(addressData.numero).trim() === "") {
      validationErrors.numero = "Informe o número.";
    }

    if (!addressData.bairro || String(addressData.bairro).trim() === "") {
      validationErrors.bairro = "Informe o bairro.";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    if (edit) {

      handleUpdateUser(4);

    } else {

      if (indexStep !== -1) {
        setStepCompletedAtIndex(indexStep, true);
      }

      setMensagem("");
      handleNextStep();
    }
  };

  return (
    <div className={styles.container} data-testid="cadastro-endereco-form">
      <div className={styles.card}>
        <div className={styles.title}>
          Dados de Endereço
        </div>
        {mensagem && <Typography color="error">{mensagem}</Typography>}
        {/* início container inputs */}
        <div className={styles.containerInputs}>
          <div className={styles.inputGroup3}>
            <label className={styles.titleInput}>
              CEP *
            </label>
            <CepField
              value={addressData.cep || ""}
              onCepChange={handleCEPChange}
              customClassName={styles.input}
              error={!!errors.cep}
              helperText={errors.cep}
            />
          </div>
          <div className={styles.inputGroup3}>
            <label className={styles.titleInput}>
              Cidade *
            </label>
            <TextField
              size="small"
              variant="standard"
              placeholder=""
              fullWidth
              label=""
              required
              value={addressData.cidade || ""}
              error={!!errors.cidade}
              helperText={errors.cidade}
              onChange={(e) => handleChange(e, "cidade")}
              InputLabelProps={{
                shrink: false,
              }}
              InputProps={{
                className: styles.input,
                disableUnderline: true,
              }}
            />
          </div>
          <div className={styles.inputGroup3}>
            <label className={styles.titleInput}>
              UF *
            </label>
            <SelectField
              label=""
              value={addressData.uf || ""}
              error={!!errors.uf}
              helperText={errors.uf}
              onChange={(e) =>
                setAddressData((prev) => ({
                  ...prev,
                  uf: e,
                }))
              }
              options={estadosBrasileiros.map((estado) => ({
                nome: estado.sigla,
              }))}
              required
            />
          </div>
          <div className={styles.inputGroup8}>
            <label className={styles.titleInput}>
              Endereço *
            </label>
            <TextField
              size="small"
              variant="standard"
              label=""
              fullWidth
              required
              value={addressData.logradouro || ""}
              error={!!errors.logradouro}
              helperText={errors.logradouro}
              onChange={(e) => handleChange(e, "logradouro")}
              inputProps={{ maxLength: 250 }}
              InputLabelProps={{
                shrink: false,
              }}
              InputProps={{
                className: styles.input,
                disableUnderline: true,
              }}
            />
          </div>
          <div className={styles.inputGroup4}>
            <label className={styles.titleInput}>
              Número *
            </label>
            <TextField
              size="small"
              type="text"
              placeholder=""
              variant="standard"
              autoFocus={false}
              fullWidth
              data-testid="nome"
              required
              value={addressData.numero || ""}
              onChange={handleNumberChange}
              error={!!errors.numero}
              helperText={errors.numero}
              inputProps={{ maxLength: 250 }}
              InputLabelProps={{
                shrink: false,
              }}
              InputProps={{
                className: styles.input,
                disableUnderline: true,
              }}
            />
          </div>
          <div className={styles.inputGroup2}>
            <label className={styles.titleInput}>
              Complemento
            </label>
            <TextField
              size="small"
              placeholder=""
              variant="standard"
              autoFocus={false}
              fullWidth
              data-testid="nome"
              required
              value={addressData.complemento || ""}
              onChange={(e) => handleChange(e, "complemento")}
              inputProps={{ maxLength: 250 }}
              InputLabelProps={{
                shrink: false,
              }}
              InputProps={{
                className: styles.input,
                disableUnderline: true,
              }}
            />
          </div>

          <div className={styles.inputGroup2}>
            <label className={styles.titleInput}>
              Bairro *
            </label>
            <TextField
              size="small"
              placeholder=""
              variant="standard"
              autoFocus={false}
              fullWidth
              data-testid="nome"
              value={addressData.bairro || ""}
              error={!!errors.bairro}
              helperText={errors.bairro}
              onChange={(e) => handleChange(e, "bairro")}
              required
              inputProps={{ maxLength: 250 }}
              InputLabelProps={{
                shrink: false,
              }}
              InputProps={{
                className: styles.input,
                disableUnderline: true,
              }}
            />
          </div>
        </div>
        {/* Fim container inputs */}
      
        {!edit ? (
          <div className={styles.buttonContainer}>
            <Button 
              variant="contained" // Use 'contained' para botÃµes com cor de fundo
              sx={{
                width: { xs: '136px', sm: '168px' }, 
                height: { xs: '42px', sm: '46px' },
                paddingY: 2, // 8px (MUI spacing unit)
                paddingX: 6, // 24px (MUI spacing unit)
                backgroundColor: '#2C3D8F',
                color: 'white',
                fontWeight: 500, 
                textAlign: 'center', 
                borderRadius: '9999px',
                '&:hover': {
                  backgroundColor: '#4556A8',
                  boxShadow: 'none', 
                },
                transition: 'background-color 200ms ease-in-out', 
              }}
              color="primary"
              onClick={handlePrevStep}
            >
              Voltar
            </Button>
            <Button
              variant="contained"
              sx={{
                width: { xs: '136px', sm: '168px' }, 
                height: { xs: '42px', sm: '46px' },
                paddingY: 2, // 8px (MUI spacing unit)
                paddingX: 6, // 24px (MUI spacing unit)
                backgroundColor: '#5A81FA',
                color: 'white',
                fontWeight: 500, 
                textAlign: 'center', 
                borderRadius: '9999px',
                '&:hover': {
                  backgroundColor: '#7A9BFB',
                  boxShadow: 'none', 
                },
                transition: 'background-color 200ms ease-in-out', 
              }}
              className={styles.nextbutton}
              onClick={handleSubmit}
            >
              Próximo
            </Button>
          </div>
        ) : (
          <Button
            variant="contained"
            sx={{
              width: { xs: '136px', sm: '168px' }, 
              height: { xs: '42px', sm: '46px' },
              paddingY: 1, // 8px (MUI spacing unit)
              paddingX: 6, // 24px (MUI spacing unit)
              backgroundColor: '#5A81FA',
              color: 'white',
              fontWeight: 500, 
              textAlign: 'center', 
              borderRadius: '9999px',
              '&:hover': {
                backgroundColor: '#7A9BFB',
                boxShadow: 'none', 
              },
              transition: 'background-color 200ms ease-in-out', 
            }}
            disabled={loadingUpdate} 
            className={`${styles_button.buttonPrimary} ${(loadingUpdate) ? styles_button.buttonLoad : ''} `}
            onClick={handleSubmit}
          >
            {loadingUpdate ? (
              <>
              <div className={styles_button.spinner}></div>
              <span>Salvando...</span>
              </>
            ) : (
            <span>Salvar</span>
            )}
          </Button>
        )}
      </div>
    </div>
  );
};

export default EnderecoForm;

